"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _overrides = require("../helpers/overrides");
var _styledComponents = require("./styled-components");
var _omitDollarPrefixedKeys = _interopRequireDefault(require("./omit-dollar-prefixed-keys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// @ts-ignore
const Icon = (props, ref) => {
  const {
    children,
    title,
    size,
    color,
    overrides = {},
    ...restProps
  } = props;
  const [Svg, overrideProps] = (0, _overrides.getOverrides)(overrides.Svg, _styledComponents.Svg);
  // Determine how/which props are passed based on if the component is a Styletron component.
  // @ts-expect-error __STYLETRON__ not in React.AbstractcomponentStatics
  const passThroughProps = Svg.__STYLETRON__ ? {
    title,
    $color: color,
    $size: size,
    ...restProps,
    ...overrideProps
  } : {
    title,
    color,
    size,
    ...(0, _omitDollarPrefixedKeys.default)(restProps),
    ...(0, _omitDollarPrefixedKeys.default)(overrideProps)
  };
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-baseweb": "icon",
    ref: ref
  }, passThroughProps), title ? /*#__PURE__*/React.createElement("title", null, title) : null, children);
};
var _default = exports.default = /*#__PURE__*/React.forwardRef(Icon);